import { Decorative } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web/common/localization";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import { HeroSection } from "@faire/retailer/views/careers/__internal__/components/HeroSection";

export const JobOpeningsHeroSection: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const headerText = strictLocalize({
    defaultMessage: "Interested in joining our team?",
    description: {
      text: "eyebrow font for the hero section of careers job openings page",
      img: "https://cdn.faire.com/fastly/246bf3f95d89357b3b0863bead3911ca473d1e4e750a26b50ef8c36716fa6e63.png",
    },
  });
  const eyebrowText = strictLocalize({
    defaultMessage: "Careers at faire",
    description: {
      text: "eyebrow font for the hero section of careers job openings page",
      img: "https://cdn.faire.com/fastly/d48951a11d79ac46338ea8fe804030d357a69595e09b0b4554f21da54a5edf3b.png",
    },
  });
  const IMAGES = [
    "https://cdn.faire.com/fastly/5819985503dbb4c21748a7eb67951c137c8f90d274107b8c8c7abb6fdf8ea01f.png",
  ];

  return (
    <HeroSection
      eyebrowText={eyebrowText}
      heroImages={IMAGES}
      backgroundColor={Decorative.tint.neutral}
    >
      <MobileHeaderTextWidth
        variant={{
          mobileAndAbove: "displayMSerifRegular",
          desktopAndAbove: "displayLSerifRegular",
        }}
      >
        {headerText}
      </MobileHeaderTextWidth>
      <Spacer height={{ mobileAndAbove: "2x", desktopAndAbove: "3x" }} />
      <MobileTextWidth
        variant={{
          mobileAndAbove: "paragraphSansRegular",
          desktopAndAbove: "subheadingSansMedium",
        }}
      >
        <StrictLocalMsg
          defaultMessage="Help create a bright future for independent retailers and brands around the world."
          description={{
            text: "Line to emphasize faire's mission",
            img: "https://cdn.faire.com/fastly/246bf3f95d89357b3b0863bead3911ca473d1e4e750a26b50ef8c36716fa6e63.png",
          }}
        />
      </MobileTextWidth>
    </HeroSection>
  );
};

const MobileHeaderTextWidth = styled(Typography)`
  ${responsiveMediaQueries.mobile} {
    max-width: ${getSpacing(300)};
  }
`;

const MobileTextWidth = styled(Typography)`
  ${responsiveMediaQueries.mobile} {
    max-width: ${getSpacing(230)};
  }
`;
